module.exports = __webpack_public_path__ + "img/example_resources.275fbb0e.jpg";